/**
 * Lookbook V2 Interactive Functionality
 * Handles full row overlay show/hide and add-to-cart actions.
 * Inline cards require no JS (pure link/static behavior).
 *
 * Uses event delegation for dynamic content support.
 * Mirrors v1 patterns: data attributes, scroll locking, focus management.
 */

(function() {
  'use strict';

  // Store scroll position before locking
  var scrollPosition = 0;

  /**
   * Lock scroll on mobile to prevent background scrolling
   * when overlay is open.
   */
  function lockScroll() {
    if (window.innerWidth <= 740) {
      scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollPosition + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
    }
  }

  /**
   * Unlock scroll on mobile and restore position.
   */
  function unlockScroll() {
    if (window.innerWidth <= 740) {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      window.scrollTo(0, scrollPosition);
    }
  }

  /**
   * Close all open v2 overlays.
   */
  function closeAllOverlays() {
    document.querySelectorAll('[data-lookbook-v2-overlay]:not([hidden])').forEach(function(overlay) {
      overlay.setAttribute('hidden', '');
    });
    unlockScroll();
  }

  /**
   * Update cart count in header after add-to-cart.
   */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        var cartCountElements = document.querySelectorAll(
          '[data-cart-count], .cart-count, .cart-count-bubble'
        );

        cartCountElements.forEach(function(element) {
          element.textContent = cart.item_count;
          if (cart.item_count > 0) {
            element.classList.remove('hidden');
          }
        });
      })
      .catch(function(error) {
        console.error('Lookbook V2: Error updating cart count:', error);
      });
  }

  // -------------------------------------------------------------------------
  // Event Delegation - Click
  // -------------------------------------------------------------------------

  document.addEventListener('click', function(e) {

    // --- Trigger button: open overlay ---
    var trigger = e.target.closest('[data-lookbook-v2-trigger]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();

      var row = trigger.closest('[data-lookbook-v2-row]');
      if (!row) return;

      var overlay = row.querySelector('[data-lookbook-v2-overlay]');
      if (!overlay) return;

      // Close any other open overlays first
      document.querySelectorAll('[data-lookbook-v2-overlay]:not([hidden])').forEach(function(otherOverlay) {
        if (otherOverlay !== overlay) {
          otherOverlay.setAttribute('hidden', '');
        }
      });

      // Show this overlay
      overlay.removeAttribute('hidden');
      lockScroll();

      // Focus close button for keyboard accessibility
      var closeButton = overlay.querySelector('[data-lookbook-v2-close]');
      if (closeButton) {
        setTimeout(function() {
          closeButton.focus();
        }, 100);
      }
    }

    // --- Close button: close overlay ---
    var closeBtn = e.target.closest('[data-lookbook-v2-close]');
    if (closeBtn) {
      e.preventDefault();
      e.stopPropagation();

      var row = closeBtn.closest('[data-lookbook-v2-row]');
      var overlay = row ? row.querySelector('[data-lookbook-v2-overlay]') : null;
      var trigger = row ? row.querySelector('[data-lookbook-v2-trigger]') : null;

      if (overlay) {
        overlay.setAttribute('hidden', '');
      }

      unlockScroll();

      // Return focus to trigger for keyboard users
      if (trigger) {
        trigger.focus();
      }
    }
  });

  // -------------------------------------------------------------------------
  // Event Delegation - Keyboard (Escape)
  // -------------------------------------------------------------------------

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var openOverlay = document.querySelector('[data-lookbook-v2-overlay]:not([hidden])');
      if (openOverlay) {
        openOverlay.setAttribute('hidden', '');
        unlockScroll();

        // Return focus to trigger
        var row = openOverlay.closest('[data-lookbook-v2-row]');
        if (row) {
          var trigger = row.querySelector('[data-lookbook-v2-trigger]');
          if (trigger) {
            trigger.focus();
          }
        }
      }
    }
  });

  // -------------------------------------------------------------------------
  // Event Delegation - Add to Cart Forms
  // -------------------------------------------------------------------------

  document.addEventListener('submit', function(e) {
    var form = e.target.closest('[data-lookbook-v2-row] [data-product-form]');
    if (!form) return;

    e.preventDefault();

    var submitButton = form.querySelector('button[type="submit"]');
    var formData = new FormData(form);

    // Loading state
    submitButton.disabled = true;
    submitButton.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(data) {
      // Success feedback
      var originalText = submitButton.textContent;
      submitButton.textContent = 'Added!';
      submitButton.style.backgroundColor = 'rgb(34, 197, 94)';

      updateCartCount();
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      setTimeout(function() {
        submitButton.textContent = originalText;
        submitButton.style.backgroundColor = '';
        submitButton.disabled = false;
        submitButton.classList.remove('is-loading');
      }, 2000);
    })
    .catch(function(error) {
      console.error('Lookbook V2: Error adding to cart:', error);

      // Error feedback
      var originalText = submitButton.textContent;
      submitButton.textContent = 'Error';
      submitButton.style.backgroundColor = 'rgb(239, 68, 68)';

      setTimeout(function() {
        submitButton.textContent = originalText;
        submitButton.style.backgroundColor = '';
        submitButton.disabled = false;
        submitButton.classList.remove('is-loading');
      }, 2000);
    });
  });

})();